<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="联系人">
                  <el-input style="width: 200px" placeholder="请填写联系人" v-model="queryForm.orderContact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                  <el-input style="width: 200px" placeholder="请填写联系电话" v-model="queryForm.orderMobile"></el-input>
              </el-form-item>
              <el-form-item label="入住日期">
                  <el-date-picker
                      v-model="queryForm.checkinDate"
                      style="width: 200px"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="离店日期">
                  <el-date-picker
                      v-model="queryForm.checkoutDate"
                      style="width: 200px"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item
                  label="订单状态"
                  prop="orderStatus"
              >
                  <el-select
                      v-model="queryForm.orderStatus"
                      size="small"
                      clearable
                      placeholder="请选择订单状态"
                      style="width: 200px"
                  >
                      <el-option
                          v-for="(item,index) in hotelOrderStatusEnumList"
                          :key="index"
                          :label="item.value"
                          :value="item.key"
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="酒店房间">
                  <HotelRoom
                      style="width: 200px"
                      title="选择房间"
                      labelName="roomName"
                      labelValue="id"
                      :value="queryForm.roomId"
                      :limit="1"
                      size="small"
                      @getValue="getHotelRoomValueQueryForm"
                      :columns="ROOM_code"
                      :searchs="ROOM_search"
                      dataListUrl="/mall/hotelroom/findList"
                      entityBeanName="mallHotelRoom"
                      queryEntityUrl="/mall/hotelroom/get"
                  >
                  </HotelRoom>
              </el-form-item>
              <el-form-item label="所属酒店">
                  <hotel
                      style="width: 200px"
                      title="所属酒店"
                      labelName="hotelName"
                      labelValue="id"
                      :value="queryForm.hotelId"
                      :limit="1"
                      size="small"
                      @getValue="getHotelValueQueryForm"
                      :columns="HOTEL_code"
                      :searchs="HOTEL_search"
                      dataListUrl="/mall/hotel/findList"
                      entityBeanName="mallHotel"
                      queryEntityUrl="/mall/hotel/get"
                  >
                  </hotel>
              </el-form-item>
              <el-form-item label="酒店用户">
                  <GridSelectU
                      style="width: 200px"
                      title="选择用户"
                      labelName="userName"
                      labelValue="id"
                      :value="queryForm.userId"
                      :limit="1"
                      size="small"
                      placeholder="请选择用户"
                      @getValue="getUserValueQueryForm"
                      :columns="USER_code"
                      :searchs="USER_search"
                      dataListUrl="/mpp/user/findList"
                      entityBeanName="mppUser"
                      queryEntityUrl="/mpp/user/get"
                  >
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMallHotelOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addMallHotelOrder"-->
<!--        >新建</el-button>-->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMallHotelOrder(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMallHotelOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMallHotelOrderList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMallHotelOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mallHotelOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="roomId"
            label="房间"
            width="180"
        >
            <template slot-scope="scop">
                <div>{{ scop.row.room.roomName }}</div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="hotelId"
            label="酒店"
            width="280"
        >
            <template slot-scope="scop">
                <div>{{ scop.row.hotel.hotelName }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderNumber"
        label="订单数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderDays"
        label="预定天数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderContact"
        label="联系人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderMobile"
        label="联系电话"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderRemarks"
        label="备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="arrivalTime"
        label="预计到店时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="checkinDate"
        label="入住日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="checkoutDate"
        label="离店日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cancelTime"
        label="取消时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payTime"
        label="支付时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="checkinTime"
        label="入住时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="commentTime"
        label="评价时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scop">
              <div>{{ computeHotelOrderStatus(scop.row.orderStatus) }}</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
      <template slot-scope="scope">
        <div v-if="scope.row.user">
            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
        </div>
        <div v-else>--</div>
      </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMallHotelOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editMallHotelOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteMallHotelOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mallHotelOrderStates[mallHotelOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mallHotelOrder"
          ref="mallHotelOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单价格"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.orderPrice"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单数量"
            prop="orderNumber"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.orderNumber"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="预定天数"
            prop="orderDays"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.orderDays"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="orderContact"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.orderContact"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="orderMobile"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.orderMobile"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="orderRemarks"
          >
              <el-input
                  type="textarea"
                  autosize
                  style="width: 200px"
                  v-model="mallHotelOrder.orderRemarks"
                  :disabled="mallHotelOrderState == 'check'"
              >
              </el-input>
          </el-form-item>
          <el-form-item
            label="预计到店时间"
            prop="arrivalTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.arrivalTime"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="入住日期"
            prop="checkinDate"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.checkinDate"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="离店日期"
            prop="checkoutDate"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.checkoutDate"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="取消时间"
            prop="cancelTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.cancelTime"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付时间"
            prop="payTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.payTime"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="入住时间"
            prop="checkinTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.checkinTime"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="评价时间"
            prop="commentTime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mallHotelOrder.commentTime"
              :disabled="mallHotelOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
              <el-select
                  v-model="mallHotelOrder.orderStatus"
                  size="small"
                  clearable
                  placeholder="请选择订单状态"
                  :disabled="mallHotelOrderState == 'check'"
                  style="width: 200px"
              >
                  <el-option
                      v-for="(item,index) in hotelOrderStatusEnumList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="房间"
            prop="roomId"
          >
              <hotel-room
                  style="width: 200px"
                  title="选择房间"
                  labelName="roomName"
                  labelValue="id"
                  :value="mallHotelOrder.roomId"
                  :disabled="mallHotelOrderState == 'check'"
                  :limit="1"
                  :stateDisabled="mallHotelOrderState == 'check'"
                  size="small"
                  @getValue="getHotelRoomValue"
                  :columns="ROOM_code"
                  :searchs="ROOM_search"
                  dataListUrl="/mall/hotelroom/findList"
                  entityBeanName="mallHotelRoom"
                  queryEntityUrl="/mall/hotelroom/get"
              >
              </hotel-room>
          </el-form-item>
            <el-form-item label="所属酒店" prop="hotelId">
                <hotel
                    style="width: 200px"
                    title="选择酒店"
                    :disabled="mallHotelOrderState == 'check'"
                    labelName="hotelName"
                    labelValue="id"
                    :value="mallHotelOrder.hotelId"
                    :limit="1"
                    :stateDisabled="mallHotelOrderState == 'check'"
                    size="small"
                    @getValue="getHotelRoomValue"
                    :columns="HOTEL_code"
                    :searchs="HOTEL_search"
                    dataListUrl="/mall/hotel/findList"
                    entityBeanName="mallHotel"
                    queryEntityUrl="/mall/hotel/get"
                >
                </hotel>
            </el-form-item>
            <el-form-item
                label="店铺管理"
                prop="userId"
            >
                <GridSelectU
                    style="width: 200px"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="mallHotelOrder.userId"
                    :limit="1"
                    :disabled="mallHotelOrderState == 'check'"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="getUserValue"
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelectU>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mallHotelOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import Hotel from '@/components/gridselect/gidselect.vue';
import HotelRoom from '@/components/gridselect/gidselect.vue';
import { USER, USER_SEARCH, HOTEL, HOTEL_SEARCH, ROOM, ROOM_SEARCH } from "@/utils/constant"
export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        Hotel,
        HotelRoom
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMallHotelOrderList();
                    this.getMallHotelOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMallHotelOrderList();
                    this.getMallHotelOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                HOTEL_code: HOTEL,
                HOTEL_search: HOTEL_SEARCH,
                ROOM_code: ROOM,
                ROOM_search: ROOM_SEARCH,
                hotelOrderStatusEnumList: [],

                queryForm:{
                     orderPrice: '', //订单价格
                     orderNumber: '', //订单数量
                     orderDays: '', //预定天数
                     orderContact: '', //联系人
                     orderMobile: '', //联系电话
                     orderRemarks: '', //备注
                     arrivalTime: '', //预计到店时间
                     checkinDate: '', //入住日期
                     checkoutDate: '', //离店日期
                     cancelTime: '', //取消时间
                     payTime: '', //支付时间
                     checkinTime: '', //入住时间
                     commentTime: '', //评价时间
                     orderStatus: '', //订单状态
                     roomId: '', //房间
                     hotelId: '', //店铺
                     userId: '', //用户
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mallHotelOrderState: 'add',
                mallHotelOrderStates: {
                    add: '新建房间',
                    check: '查看房间',
                    edit: '修改房间'
                },

                multipleSelection: [],
                mallHotelOrderList: [],
                mallHotelOrder: {
                    orderPrice: '', //订单价格
                    orderNumber: '', //订单数量
                    orderDays: '', //预定天数
                    orderContact: '', //联系人
                    orderMobile: '', //联系电话
                    orderRemarks: '', //备注
                    arrivalTime: '', //预计到店时间
                    checkinDate: '', //入住日期
                    checkoutDate: '', //离店日期
                    cancelTime: '', //取消时间
                    payTime: '', //支付时间
                    checkinTime: '', //入住时间
                    commentTime: '', //评价时间
                    orderStatus: '', //订单状态
                    roomId: '', //房间
                    hotelId: '', //店铺
                    userId: '', //用户
                },
                btnLoading: false,

                rules: {
                    orderPrice: [{ required: true, message: '订单价格不能为空', trigger: 'blur' }],
                    orderNumber: [{ required: true, message: '订单数量不能为空', trigger: 'blur' }],
                    orderDays: [{ required: true, message: '预定天数不能为空', trigger: 'blur' }],
                    orderContact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                    orderMobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    orderRemarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    arrivalTime: [{ required: true, message: '预计到店时间不能为空', trigger: 'blur' }],
                    checkinDate: [{ required: true, message: '入住日期不能为空', trigger: 'blur' }],
                    checkoutDate: [{ required: true, message: '离店日期不能为空', trigger: 'blur' }],
                    cancelTime: [{ required: true, message: '取消时间不能为空', trigger: 'blur' }],
                    payTime: [{ required: true, message: '支付时间不能为空', trigger: 'blur' }],
                    checkinTime: [{ required: true, message: '入住时间不能为空', trigger: 'blur' }],
                    commentTime: [{ required: true, message: '评价时间不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                    roomId: [{ required: true, message: '房间不能为空', trigger: 'blur' }],
                    hotelId: [{ required: true, message: '店铺不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMallHotelOrderList();
            this.getHotelOrderStatusEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMallHotelOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mallHotelOrderList = [];
            },
            resetDialog() {
                this.mallHotelOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderPrice: '', //订单价格
                      orderNumber: '', //订单数量
                      orderDays: '', //预定天数
                      orderContact: '', //联系人
                      orderMobile: '', //联系电话
                      orderRemarks: '', //备注
                      arrivalTime: '', //预计到店时间
                      checkinDate: '', //入住日期
                      checkoutDate: '', //离店日期
                      cancelTime: '', //取消时间
                      payTime: '', //支付时间
                      checkinTime: '', //入住时间
                      commentTime: '', //评价时间
                      orderStatus: '', //订单状态
                      roomId: '', //房间
                      hotelId: '', //店铺
                      userId: '', //用户
                };
                this.getMallHotelOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.mallHotelOrder = {
                      orderPrice: '', //订单价格
                      orderNumber: '', //订单数量
                      orderDays: '', //预定天数
                      orderContact: '', //联系人
                      orderMobile: '', //联系电话
                      orderRemarks: '', //备注
                      arrivalTime: '', //预计到店时间
                      checkinDate: '', //入住日期
                      checkoutDate: '', //离店日期
                      cancelTime: '', //取消时间
                      payTime: '', //支付时间
                      checkinTime: '', //入住时间
                      commentTime: '', //评价时间
                      orderStatus: '', //订单状态
                      roomId: '', //房间
                      hotelId: '', //店铺
                      userId: '', //用户
                };
            },
            submitForm() {
                if (this.mallHotelOrderState == 'add') {
                    this.$refs.mallHotelOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mall/hotelorder/add`,{ ...this.mallHotelOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMallHotelOrderList();
                                    this.resetDialog();
                                    this.getMallHotelOrderList();
                                }
                            });
                        }
                    });
                } else if (this.mallHotelOrderState == 'edit') {
                    this.$refs.mallHotelOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mallHotelOrder.user
                            delete this.mallHotelOrder.hotel
                            delete this.mallHotelOrder.room
                            post(`/mall/hotelorder/edit`,{ ...this.mallHotelOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMallHotelOrderList();
                                    this.resetDialog();
                                    this.getMallHotelOrderList();
                                }
                            });
                        }
                    });
                }
            },
            addMallHotelOrder() {
                this.showDialog = true;
                this.mallHotelOrderState = 'add';
            },
            checkMallHotelOrder(mallHotelOrderId) {
                console.log(mallHotelOrderId);
                this.currentMallHotelOrderId = mallHotelOrderId;

                this.getMallHotelOrderById();
                this.showDialog = true;
                this.mallHotelOrderState = 'check';
            },
            editMallHotelOrder(mallHotelOrderId) {
                console.log('mallHotelOrder', mallHotelOrderId);
                if (mallHotelOrderId) {
                    this.currentMallHotelOrderId = mallHotelOrderId;
                    this.getMallHotelOrderById();
                } else {
                    this.mallHotelOrder = { ...this.mallHotelOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mallHotelOrderState = 'edit';
            },
            deleteMallHotelOrder(mallHotelOrderId) {
                let ids = '';
                if (mallHotelOrderId) {
                    ids = mallHotelOrderId;
                } else {
                    ids = this.multipleSelection.map((mallHotelOrder) => mallHotelOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mall/hotelorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallHotelOrderList();
                                this.getMallHotelOrderList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMallHotelOrderList() {
                this.resetMallHotelOrderList();
                this.getMallHotelOrderList();
            },
            getMallHotelOrderList(query = {}) {
                this.loading = true;
                get(`/mall/hotelorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mallHotelOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMallHotelOrderById() {
                get(`/mall/hotelorder/get`,{ id: this.currentMallHotelOrderId }).then((res) =>{
                    if(res.success){
                      this.mallHotelOrder = { ...this.mallHotelOrder, ...res.mallHotelOrder };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMallHotelOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/mall/hotelorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mall/hotelorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mall/hotelorder/importData`,formData);
              this.refreshMallHotelOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMallHotelOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMallHotelOrderList();
            },
            getHotelRoomValue(value){
                this.mallHotelRoom.hotelId = value
            },
            getUserValue(value){
                this.mallHotelRoom.userId = value
            },
            getHotelOrderStatusEnum(){
                get('/mpp/utils/getEnum',{ enumType:'hotel_order_status' }).then((res)=>{
                    if(res.success){
                        this.hotelOrderStatusEnumList = res.enumList
                    }
                })
            },
            computeHotelOrderStatus(status){
                for (let i = 0; i < this.hotelOrderStatusEnumList.length; i++) {
                    if(this.hotelOrderStatusEnumList[i].key === status){
                        return  this.hotelOrderStatusEnumList[i].value
                    }
                }
            },
            getUserValueQueryForm(value){
                this.queryForm.userId = value
            },
            getHotelValueQueryForm(value){
                this.queryForm.hotelId = value
            },
            getHotelRoomValueQueryForm(value){
                this.queryForm.roomId = value
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>